import { createFileRoute } from "@tanstack/react-router";
import { CaseStudiesPage } from "@/pages/proof/ProofPages";
import { seoHead } from "@/lib/seo/head";
export const Route = createFileRoute("/case-studies/")({ head: () => seoHead({ title: "LeadXkids Case Studies", description: "Verified LeadXkids case studies with clearly labelled evidence and limitations.", noindex: true, follow: true }), component: CaseStudiesPage });
